import {Injectable} from '@angular/core';
import {AlertService} from '@services/helpers/alert/alert.service';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ErrorHelperService {

  constructor(private alertService: AlertService) {
  }

  handleErr(err: any): void {
    this.displayErrorMsg(err);
    if (!environment.production) {
      console.error('There was an Error:');
      console.error(err);
    }
  }

  /**
   * Displays an error message based on the error object that is pushed through
   * @param err The error object
   * @private
   */
  private displayErrorMsg(err: any): void {
    let errMsg = (err && err.message) ? err.message : null;
    if (!errMsg && err.msg) {
      errMsg = err.msg;
    }

    if (!errMsg) {
      errMsg = 'There was an unknown error processing your request. Please try again or contact an Administrator.';
    }

    this.alertService.danger(errMsg);
  }
}
